import React from 'react';
import {Col, Row} from 'reactstrap';

const RenderSkills = ({styles, title, skills, asList, commaSeparated}) => {

	let skillsListNode = null;
	if (asList) {
		skillsListNode = (
			<ul className="fa-ul">
				{
					skills.map((skill, index) => (
						<li key={index}><span className="fa-li"><i className="fa fa-long-arrow-right"></i></span>{skill}</li>)
					)
				}
			</ul>
		);
	} else if (commaSeparated) {
		skillsListNode = (
			<div>
				{skills.join(", ")}
			</div>
		)
	} else {
		//default for now
		skillsListNode = (
			<div className="d-flex flex-row flex-wrap">
				{
					skills.map((skill, index) => (
						<span key={index} style={{margin: "0.5rem 0.5rem 0.5rem 0rem"}}
									className="flex-fill text-center rounded-pill bg-primary text-light px-2 p-1 m-1">{skill}</span>)
					)
				}
			</div>
		)
	}

	return (
		<div className="skills-group" style={{paddingBottom: "0rem"}}>
			<div style={styles.section.item}>
				<div style={styles.section.item.title}>
					{title + ": "}
				</div>
				{skillsListNode}
			</div>
		</div>
	);
};

const Skills = ({styles, data, icon, asList, commaSeparated}) => {
	return (
		<div className="skills-section" style={styles.section}>
			<Row style={{paddingBottom: "0rem"}}>
				<Col>
					<h3 style={{
						...styles.section.title, 
						// borderBottom: "1px solid #ccc"
						marginBottom: '0.25rem',
						paddingBottom: '0.25rem',
					}}>
						Skills<span className={icon} style={{padding: "0.2rem"}}></span>
					</h3>

					{
						data.map((item, index) => {
							return (
								<RenderSkills styles={styles} title={item.title} skills={item.data} key={index} asList={asList}
															commaSeparated={commaSeparated}/>
							)
						})
					}
				</Col>
			</Row>
		</div>
	);
};

export default Skills;